<template>
  <div
    class="bg-surface-default-low border-static-default-low overflow-y-auto border-r"
  >
    <RevAccordionList :has-external-borders="false">
      <ProductDetails
        :orderline="customerRequest.orderline"
        :product="customerRequest.product"
      />
      <Returns :customerRequestId="customerRequest.customerRequestId" />
      <OrderHistory :orderline="customerRequest.orderline" />
      <Warranty
        v-if="customerRequest.orderline.coverage"
        :coverage="customerRequest.orderline.coverage"
      />
      <Insurance
        :chillpack="customerRequest.orderline.coverage?.chillpackInsurance"
        :policies="customerRequest.orderline.coverage?.insurancePolicies"
        :trustpack="customerRequest.orderline.coverage?.trustpackInsurance"
      />
      <Customer
        :customer="customerRequest.customer"
        :orderline="customerRequest.orderline"
      />
      <Attachments
        :attachments="customerRequest.attachments"
        :customerRequestId="customerRequest.customerRequestId"
        :lastAttachmentSharedAt="customerRequest.lastAttachmentSharedAt"
      />
      <Events :careFolderEvents="customerRequest.events" :claims />
    </RevAccordionList>
    <RevDivider />
    <p class="text-static-default-low p-16">
      <FormattedMessage class="body-1" :definition="translations.needHelp">
        <template #sscLink>
          <RevLink
            target="_blank"
            to="https://backmarket.my.site.com/ssc/s/submit-new-request"
          >
            <span class="text-static-default-low body-1-bold">
              {{ i18n(translations.SSCLinkLabel) }}
            </span>
          </RevLink>
        </template>
      </FormattedMessage>
    </p>
  </div>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionList } from '@ds/components/AccordionList'
import { RevDivider } from '@ds/components/Divider'
import { RevLink } from '@ds/components/Link'

import type { CareFolder } from '~/api/care-folders/types/care-folder'
import type { GetCustomerRequestSellerDiscussionResponse } from '~/api/customer-request/types'

import translations from './Details.translations'
import Attachments from './components/Attachments/Attachments.vue'
import Customer from './components/Customer/Customer.vue'
import Events from './components/Events/Events.vue'
import Insurance from './components/Insurance/Insurance.vue'
import OrderHistory from './components/OrderHistory/OrderHistory.vue'
import ProductDetails from './components/ProductDetails/ProductDetails.vue'
import Returns from './components/Returns/Returns.vue'
import Warranty from './components/Warranty/Warranty.vue'

const i18n = useI18n()

defineProps<{
  customerRequest: CareFolder
  claims: GetCustomerRequestSellerDiscussionResponse
}>()
</script>
